import { useAtomValue } from "jotai";

import { H1, H3, InternalLink, P } from "@sorcery/ui";
import { fromNow } from "@sorcery/utils/universal/time";

import { Metadata } from "~/components/molecules/Metadata";
import { commentsJotai, deckJotai } from "~/state/deckJotai";
import { userPath } from "~/utils/paths";

export const DeckSplash = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const { name, format, updatedAt, user, _count } = useAtomValue(deckJotai)!;
  const comments = useAtomValue(commentsJotai);
  return (
    <div>
      <H1 className="!mb-0 line-clamp-2 pt-2 !text-3xl lg:!text-4xl 2xl:!text-7xl">{name}</H1>
      <H3 className="!mb-0 transition-all">
        <InternalLink href={userPath(user.id)}>
          <span className="hover:text-primary-light text-primary hover:underline">
            @{user.username}
          </span>
        </InternalLink>
      </H3>
      <P className="!mb-0 font-medium capitalize">{format}</P>

      <div className="flex">
        <P className="!mb-0 mr-2 font-medium">Updated {fromNow(updatedAt)}</P>
        <Metadata
          views={_count.views}
          comments={comments?.length ?? 0}
          likes={_count.likes}
          showText={true}
        />
      </div>
    </div>
  );
};
